module.exports = __webpack_public_path__ + "img/upwork-review-1.5e95a2be.jpg";